export enum ListViewFilterElementCapability {
  labelable = 1,
  selectable = 2,
  placeholderable = 3,
  propertySearchable = 4,
  propertyDateTimeFilterable = 5,
  datetimeable = 6,
  defaultable= 7,
  conditionable = 8,
  containerable = 9,
  verticalAlignable = 10,
  columnLayoutable = 11,
  helpTextable = 12,
  propertyDropdownFilterable = 13,
}
